import { createReducer } from '@reduxjs/toolkit';

import { TYPES } from '../../common/constants';

const fetchCommonIssuesDone = (_, { payload }) => {
  
  return [
    ...payload,
  ];
};

const saveCommonIssuesDone = (commonIssues, { payload }) => {
  return [
    ...commonIssues,
    payload,
  ];
}
const updateCommonIssuesDone = (commonIssues, { payload }) => {

  return commonIssues.map( c => {
    if( c.id === payload.id){
      return payload
    }
    return c
 })
}

const deleteCommonIssueDone = (commonIssues,{ payload }) =>{
  return commonIssues.filter( c => c.id !== payload)
}

const clearCommonIssuesDone = () => {
  return initialState
}
const initialState = [];

export default createReducer(initialState, {
  [TYPES.FETCH_COMMON_ISSUES_DONE]: fetchCommonIssuesDone,
  [TYPES.SAVE_COMMON_ISSUE_DONE]: saveCommonIssuesDone,
  [TYPES.UPDATE_COMMON_ISSUE_DONE]: updateCommonIssuesDone,
  [TYPES.DELETE_COMMON_ISSUE_DONE]:deleteCommonIssueDone,
  [TYPES.CLEAR_COMMON_ISSUE_DONE]: clearCommonIssuesDone
});
